export default __webpack_public_path__ + "static/media/card1.d9ca5395.png";